module.exports = __webpack_public_path__ + "img/04.b65fa77b.jpg";